import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import s from './styles.module.scss'

export const UmrahEmpty = () => {
  const { t } = useTranslation()

  return (
    <div className={s.container}>
      <p className={clsx('bold-24', s.title)}>{t('umrah_block.empty_title')}</p>
      <p className={clsx('medium-14', s.subtitle)}>
        {t('umrah_block.empty_subtitle')}
      </p>
    </div>
  )
}
